import React from 'react';
import MuiBadge, { BadgeProps as MuiBadgeProps } from '@mui/material/Badge';
import { BpDesignSystem } from '../../types';

export type BadgeProps = BpDesignSystem.PropsWithChildren<MuiBadgeProps>;

export const Badge = ({ dataTest, ...props }: BadgeProps) => {
  return <MuiBadge data-test={dataTest} {...props} />;
};
